<template>
  <div :class="[{ 'has-error': hasErrors }, groupClass]">
    <slot></slot>
    <div v-show="showList && hasDangerErrors" class="form-input-hint" :class="{ relative: !positionAbsolute }">
      <div v-for="e in errors.filter((x) => x.messageType === 'Danger')" :key="e.key">{{ e.message }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: { type: String },
    label: { type: String },
    showList: { type: Boolean, default: true },
    groupClass: { default: 'form-group' },
    positionAbsolute: { default: true },
    errors: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    hasErrors() {
      return this.errors && this.errors.length > 0
    },
    hasFeedback() {
      return this.hasErrors() && this.errors[0].MessageType !== 'Required'
    },
    hasDangerErrors() {
      return this.errors.filter((x) => x.messageType === 'Danger').length > 0
    }
  }
}
</script>
